import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { navigateOutline } from 'ionicons/icons'
import { formatAssignmentLeaveTime } from '../../../helpers/datetime'
import { DetailWithIcon } from './DetailWithIcon'

/** "Depart" time detail, compact like v1: 7AM. */
export const LeaveTimeDetail = ({
  assignment,
}: {
  assignment: Parameters<typeof formatAssignmentLeaveTime>[0]
}) => {
  const { _ } = useLingui()
  const leaveTime = formatAssignmentLeaveTime(assignment)
  if (!leaveTime) return null
  return (
    <DetailWithIcon
      icon={navigateOutline}
      header={_(msg`Depart`)}
      body={leaveTime}
    />
  )
}
